import * as React from 'react';
import PropTypes from 'prop-types';
import Button from '@mui/material/Button';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Dialog from '@mui/material/Dialog';
import { FormLabel } from '@mui/material';
import { useTranslation } from 'react-i18next';
import SaveButton from '../Common/SaveButton';
import { useAsyncCallback } from '../../hooks/useAsyncCallback';

export default function ConfirmDeleteDialog (props) {
    const { onClose, open, title, content, ...other } = props;
    const { t } = useTranslation();

    const dialogTitle = title ?? t('common.confirmDelete');
    const dialogContent = content ?? t('common.confirmDeleteDefault');

    const handleCancel = () => {
        onClose(false);
    };

    const { run: handleOk, loading: saving } = useAsyncCallback(async () => {
        await onClose(true);
    });

    return (
        <Dialog
            sx={{ '& .MuiDialog-paper': { width: '80%', maxHeight: 435 } }}
            maxWidth="xs"
            open={open}
            {...other}
        >
            <DialogTitle>{dialogTitle}</DialogTitle>
            <DialogContent dividers>
                <FormLabel>{dialogContent}</FormLabel>
            </DialogContent>
            <DialogActions>
                <Button autoFocus onClick={handleCancel} disabled={saving}>
                    {t('common.cancel')}
                </Button>
                <SaveButton loading={saving} onClick={handleOk}>{t('common.ok')}</SaveButton>
            </DialogActions>
        </Dialog>
    );
}

ConfirmDeleteDialog.propTypes = {
    onClose: PropTypes.func.isRequired,
    open: PropTypes.bool.isRequired,
    title: PropTypes.string,
    content: PropTypes.string,
};
